import React from 'react';
import { useTranslation } from 'react-i18next';

const TEAL = '#14b8a6';
const MUTED = '#94a3b8';

function LangButton({ code, label, active, onClick, compact, scale }) {
  const padY = Math.round((compact ? 4 : 5) * scale);
  const padX = Math.round((compact ? 8 : 10) * scale);
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      aria-pressed={active}
      style={{
        background: active ? 'rgba(20,184,166,0.15)' : 'transparent',
        border: `1px solid ${active ? TEAL : 'rgba(255,255,255,0.12)'}`,
        borderRadius: Math.max(4, Math.round(6 * scale)),
        padding: `${padY}px ${padX}px`,
        fontSize: Math.round((compact ? 11 : 12) * scale),
        fontWeight: 700,
        color: active ? TEAL : MUTED,
        cursor: 'pointer',
        fontFamily: 'inherit',
        lineHeight: 1,
      }}
    >
      {code}
    </button>
  );
}

export default function LanguageSwitcher({ compact = false, scale = 1 }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith('en') ? 'en' : 'hu';

  return (
    <div style={{ display: 'flex', gap: Math.max(2, Math.round(4 * scale)), alignItems: 'center' }}>
      <LangButton
        code="HU"
        label="Magyar"
        active={current === 'hu'}
        compact={compact}
        scale={scale}
        onClick={() => i18n.changeLanguage('hu')}
      />
      <LangButton
        code="EN"
        label="English"
        active={current === 'en'}
        compact={compact}
        scale={scale}
        onClick={() => i18n.changeLanguage('en')}
      />
    </div>
  );
}
